export default __webpack_public_path__ + "static/media/Games-1.24dd3f00.png";